import { InputOnChangeData, SearchBoxChangeEvent } from "@fluentui/react-components";
import { ScopeContext, ScopeHierarchy, ScopeItem } from "./Scopes.types";
import { CentralAdminEntityType } from "Enums/CentralAdminEntityType";

export interface ScopeSearchProps {
    searchValue?: string;
    selectedScopes?: ScopeItem[];
    context?: ScopeContext;
    hierarchy: ScopeHierarchy;
    onChange: (event: SearchBoxChangeEvent, data: InputOnChangeData) => void;
    onSearch: (scopeItem: ScopeItem[]) => void;
}

export const targetTypeToString = {
    [CentralAdminEntityType.Region]: "Region",
    [CentralAdminEntityType.Forest]: "Forest",
    [CentralAdminEntityType.Dag]: "Dag",
    [CentralAdminEntityType.Machine]: "Machine",
    [CentralAdminEntityType.Location]: "Location",
    [CentralAdminEntityType.Rack]: "Rack",
    [CentralAdminEntityType.CapacityUnit]: "CapacityUnit",
    [CentralAdminEntityType.PartitionUnit]: "PartitionUnit",
    [CentralAdminEntityType.LoadBalancer]: "LoadBalancer",
    [CentralAdminEntityType.SubRegion]: "SubRegion",
    [CentralAdminEntityType.Vip]: "Vip",
    [CentralAdminEntityType.Tenant]: "Tenant",
    [CentralAdminEntityType.TenantId]: "TenantId",
    [CentralAdminEntityType.FaultZone]: "FaultZone"
};
